import { combineReducers } from 'redux';
import apiState from './api/apiStateCheckReducer';
import uiLogic from './uiLogic';
import user from './user';
import company from './company';
import groups from './groups';
import employees from './employees';
import programs from './programs';
import twofactor from './twoFactor';
import payments from './payments';
import questions from './questions';
import reports from './reports';

export default combineReducers({
  apiState,
  uiLogic,
  user,
  company,
  groups,
  employees,
  programs,
  twofactor,
  payments,
  questions,
  reports,
});
